import React, { useState, useEffect } from 'react';
import './App.css';
import { Routes, Route, Navigate } from 'react-router-dom';

// Sayfaları import et
import Login from './pages/Login';
import HomePage from './pages/HomePage';
import Profile from './pages/Profile';
import MyReports from './pages/MyReports';
import Info from './pages/Info';
import AdminPanel from './pages/AdminPanel'; // YENİ: Admin panelini ekledik

// Firebase ve SweetAlert importları
import { auth } from './firebase'; 
import { onAuthStateChanged, signOut } from "firebase/auth";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); 

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false); 
    });
    return () => unsubscribe(); 
  }, []);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      MySwal.fire({
          icon: 'success',
          title: 'Çıkış Yapıldı',
          text: 'Başarıyla çıkış yaptınız. Güvende kalın!',
          timer: 2000,
          showConfirmButton: false
      });
    } catch (error) {
      console.error("Çıkış hatası:", error);
    }
  };

  if (loading) {
    return <div className="flex items-center justify-center h-screen bg-gray-900 text-white font-bold text-xl">Sistem Yükleniyor...</div>; 
  }

  return (
    <div className="App">
      <Routes>
        <Route path="/login" element={user ? <Navigate to="/" /> : <Login />} />
        <Route path="/" element={user ? <HomePage user={user} handleLogout={handleLogout} /> : <Navigate to="/login" />} />
        <Route path="/profilim" element={user ? <Profile /> : <Navigate to="/login" />} />
        <Route path="/ihbarlarim" element={user ? <MyReports /> : <Navigate to="/login" />} />
        <Route path="/bilgi" element={user ? <Info /> : <Navigate to="/login" />} />
        
        {/* YENİ: Admin Paneli Rotası */}
        <Route path="/admin" element={user ? <AdminPanel /> : <Navigate to="/login" />} />

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </div>
  );
}

export default App;